<template>
  <div class="right-fixed-box">
    <div class="right-box-list">
      <div class="right-box-item">
        <el-popover placement="left" trigger="hover" width="200">
          <img
            class="popover-img"
            :src="$common.getResourceUrl('gongzhonghao.jpg')"
          />
          <span class="cursor" slot="reference">
            <img :src="$common.getResourceUrl('pcweb/icon/icon_weixin.png')" />
            <span>关注我们</span>
          </span>
        </el-popover>
      </div>
      <div class="right-box-item">
        <el-popover placement="left" trigger="hover" width="200">
          <img
            class="popover-img"
            :src="$common.getResourceUrl('appdown.jpg')"
          />
          <span class="cursor" slot="reference">
            <img
              :src="$common.getResourceUrl('pcweb/icon/icon_gongzhonghao.png')"
            />
            <span>下载APP</span>
          </span>
        </el-popover>
      </div>
    </div>

    <div v-show="scrollTop > 50" class="right-box-bottom cursor" @click="toTop">
      <i class="el-icon-arrow-up"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RightFixedBox',
  components: {},
  props: {},
  data() {
    return {
      scrollTop: 0,
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('scroll', () => {
        this.scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop
      })
    })
  },
  methods: {
    toTop() {
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop =
          document.documentElement.scrollTop =
          this.scrollTop -=
            50
        if (this.scrollTop <= 0) {
          clearInterval(timeTop)
        }
      }, 7)
    },
  },
}
</script>
<style>
body.el-popup-parent--hidden .right-fixed-box {
  right: 25px;
}
</style>
<style lang="scss" scoped>
.el-popover {
  width: 200px;
  .popover-img {
    width: 100%;
    display: block;
  }
}

.right-fixed-box {
  position: fixed;
  right: 10px;
  top: 46%;
  width: 64px;
  z-index: 999;

  .right-box-list {
    width: 100%;
    box-shadow: 0px 0px 4px 0px #f5f6f7;
    border-radius: 10px;
    border: 1px solid #e9e9e9;
    background-color: #fff;
  }

  .right-box-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid #e9e9e9;
    color: #666;
    font-size: 14px;
    text-align: center;
    padding: 14px 0;
    &:last-child {
      border-bottom: none;
    }

    .cursor {
      width: 60px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        width: 26px;
        height: 26px;
        margin-bottom: 6px;
      }
      & > span {
        width: 26px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 17px;
      }
    }
  }
  .right-box-bottom {
    width: 50px;
    height: 50px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px #f5f6f7;
    border-radius: 39px;
    border: 1px solid #e9e9e9;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 15px;
    margin-left: 7px;
  }
}
</style>
